import 'isomorphic-fetch';

declare const TNEW_RESOURCES_DOMAIN;

export function alertMessage()
{
    const ALERT_MESSAGE_ID = 'siteWideAlertMessage';
    const ALERT_CANCEL_ID = 'siteWideAlertCancel';
    const SHOW_CLASS = 'site-wide-alert-show';

    let alertMessageElement = document.getElementById(ALERT_MESSAGE_ID);
    let alertCancelElement = document.getElementById(ALERT_CANCEL_ID);
    let siteBody = <HTMLElement>document.querySelector('.site-body');
    let siteHeader = document.querySelector('#siteHeader');
    let siteHeaderHeight = '';
    let curtainMenu = document.querySelector('.curtain-menu-inner');

    if (alertMessageElement && alertCancelElement) {
        document.addEventListener('DOMContentLoaded', setAlertMessageVisibility);
        alertCancelElement.addEventListener('click', cancelAlert)
    }

    function adjustSiteBody() {
        if (document.querySelector('.page-hero-heading-no-image') || (!document.querySelector('.page-hero-tint-overlay') && !document.querySelector('.home-page-js') &&
            !document.querySelector('.cal-site-body'))) {
            calcSiteHeaderHeight()

            window.addEventListener('resize', function () {
                calcSiteHeaderHeight();               
            })
        }
        else if (!document.querySelector('.cal-site-body') && !document.querySelector('.page-hero-large-parallax-alt')) {
            if (window.innerWidth < 768) {
                calcSiteHeaderHeight()
            }

            window.addEventListener('resize', function () {
                if (window.innerWidth < 768) {
                    calcSiteHeaderHeight()
                }
                else if (siteBody.hasAttribute('style')) {
                    siteBody.removeAttribute('style');                    
                }
            })
        }
    }

    function calcSiteHeaderHeight() {
        if (siteBody.hasAttribute('style')) {
            siteBody.removeAttribute('style');
        }

        // 35px buffer added to match design
        siteHeaderHeight = siteHeader.scrollHeight + 35 + 'px';
        siteBody.style.paddingTop = siteHeaderHeight;
    }

    function setAlertMessageVisibility() {
        fetch(TNEW_RESOURCES_DOMAIN + '/api/AlertMessage/ShouldShowMessage',
            {
                credentials: 'include',
            })
            .then(response => {
                if (response.ok) {
                    return response.json() as Promise<boolean>;
                }
                else {
                    // Failure case
                    console.log(response);
                }
            }).then(shouldShowMessage => {
                if (shouldShowMessage) {
                    alertMessageElement.classList.add(SHOW_CLASS);
                    adjustSiteBody();
                }
            });
    }

    function cancelAlert() {
        if (curtainMenu.hasAttribute('style')) {
            curtainMenu.removeAttribute('style');  
        }

        if (siteBody.hasAttribute('style')) {
            siteBody.removeAttribute('style');
        }

        fetch(TNEW_RESOURCES_DOMAIN + '/api/AlertMessage/CloseModal', {
            method: 'post',
            credentials: 'include', 
        })
        .then(response => {
            if (response.ok) {
                alertMessageElement.classList.remove(SHOW_CLASS);
                return response;
            }
            else {
                // Failure case
                console.log(response);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/alert-message.ts